import { initMaps } from './Maps.js';
//import { mainSlider } from './PageMain.js';
import { lock } from './LockScroll.js';
import { unlock } from './LockScroll.js';


const $slider = $('.js-slider');

if ($slider.length) {

    App.H.on('click', '.js-close-popup-slider', function () {
        $(this).closest('.js-popup-slider').removeClass('_open');

        unlock();
    });

    $slider.each(function(i) {
        const $g = $(this);
        const $container = $g.closest('.js-slider-wrap');
        //const $sliderPopup = $container.find('.js-slider-popup-btn');

        if ($g.data('mode') !== 'desktop') {
            lock();
        }

        //$sliderPopup.data('index', i);

        App.B.append(`
            <div class="popup-slider-wrap js-popup-slider" data-index="${i}">
                <button class="close-btn js-close-popup-slider">
                    <svg>
                        <use xlink:href="#sym-icon-close"></use>
                    </svg>
                </button>

                <div class="popup-slider">
                    <div class="slider-wrap__inner">
                        <div class="slider swiper-container js-popup-slider-${i}">
                            <div class="slider__inner swiper-wrapper js-popup-slider-content-${i}">

                            </div>
                        </div>
                    </div>

                    <div class="swiper-button-prev js-popup-slider-prev">
                        <svg>
                            <use xlink:href="#sym-slider-str"></use>
                        </svg>
                    </div>

                    <div class="swiper-button-next js-popup-slider-next">
                        <svg>
                            <use xlink:href="#sym-slider-str"></use>
                        </svg>
                    </div>
                </div>
            </div>
        `);

        //$g.find('.slide').first().addClass('_show');

        $g.find('img').each(function (index, el) {
            let $currImg = $(this);
            let _currImgSrc = $currImg.data('src');
            let _verticalElement = '';
            let _verticalClass = $currImg.outerHeight() > $currImg.outerWidth() ? '_vertical' : '';

            if (index === 0) {
                $currImg.attr('src', $currImg.data('src'));
            }

            if (_verticalClass.length > 0) {
                _verticalElement = `<div class="vertical-photo-back" style="background-image: url(${_currImgSrc})"></div>`;
            }

            $(`.js-popup-slider-content-${i}`).append(`
                <figure class="slide swiper-slide ${_verticalClass}">
                    <div class="slide__inner">
                        <img alt="${$(el).attr('alt')}" src="${$(el).data('src')}">
                        ${_verticalElement}
                        <div class="slide__inner-bg" style="background-image: url('${$(el).data('src')}')"></div>
                    </div>
                    <figcaption class="slide__description">${$(el).attr('alt')}</figcaption>
                </figure>
            `);
        });

        // Возможность делать множественные галереи
        $g.addClass(`js-slider-${i}`).data('index', i);
        $container.find('.js-slider-pagination').addClass(`js-slider-pagination-${i}`);

        //if ($g.data('mode') !== 'desktop' && App.W.outerWidth() > App.tabletH) {
        if ($g.data('mode') !== 'desktop' && App.W.outerWidth() > App.tabletH) {
            $g.find('.slide').first().addClass('_show');

            // Инициализация
            const swiper = new Swiper(`.js-popup-slider-${i}`, {
                loop: true,
                effect: $g.data('effect') ? $g.data('effect') : 'fade',
                slidesPerView: 1,
                followFinger: App.mobile,
                shortSwipes: App.mobile,
                longSwipes: App.mobile,
                centeredSlides: true,
                lazy: {
                    loadPrevNext: true
                },
                pagination: {
                    el: `.js-slider-pagination-${i}`,
                    type: 'bullets'
                },
                on: {
                    // для слайдера главной
                    slideChange: function () {
                        //mainSlider();

                        let $prevImg = $g.find('.swiper-slide-prev img');
                        let $nextImg = $g.find('.swiper-slide-next img');

                        if ($prevImg.hasClass('swiper-lazy-loaded')) {
                            setVerticalPhoto($prevImg);
                        }

                        if ($nextImg.hasClass('swiper-lazy-loaded')) {
                            setVerticalPhoto($nextImg);
                        }
                    }
                },
                threshold: 10,
                roundLengths: true,
                speed: 300,
                a11y: true
            });

            swiper.on('slideChange', function () {
                console.log('slide changed');
            });

            $(`.js-popup-slider[data-index=${i}]`).find('.js-popup-slider-next').on('click', () => {
                swiper.slideNext();
            });

            $(`.js-popup-slider[data-index=${i}]`).find('.js-popup-slider-prev').on('click', () => {
                swiper.slidePrev();
            });

            //$sliderPopup.on('click', function () {
            $slider.on('click', function () {
                let currIndex = $(this).data('index');

                $(`.js-popup-slider[data-index="${currIndex}"]`).addClass('_open');
                lock();
            });
        //} else {
        } else if ($g.data('mode') !== 'desktop' || App.W.outerWidth() >= App.tabletV) {
        //} else if (App.W.outerWidth() >= App.tabletV) {
            // Инициализация
            const swiper = new Swiper(`.js-slider-${i}`, {
                loop: true,
                effect: $g.data('effect') ? $g.data('effect') : 'fade',
                slidesPerView: 1,
                followFinger: App.mobile,
                shortSwipes: App.mobile,
                longSwipes: App.mobile,
                centeredSlides: true,
                lazy: {
                    loadPrevNext: true
                },
                pagination: {
                    el: `.js-slider-pagination-${i}`,
                    type: 'bullets'
                },
                on: {
                    init: function () {
                        let $img = $g.find('.swiper-slide-active img');
                        setVerticalPhoto($img);
                    },
                    // для слайдера главной
                    slideChange: function () {
                        //mainSlider();
                        let $prevImg = $g.find('.swiper-slide-prev img');
                        let $nextImg = $g.find('.swiper-slide-next img');

                        if ($prevImg.hasClass('swiper-lazy-loaded')) {
                            setVerticalPhoto($prevImg);
                        }

                        if ($nextImg.hasClass('swiper-lazy-loaded')) {
                            setVerticalPhoto($nextImg);
                        }
                    }
                },
                threshold: 10,
                roundLengths: true,
                speed: 300,
                a11y: true
            });

            /*swiper.on('slideChange', function () {
                let $prevImg = $g.find('.swiper-slide-prev img');
                let $nextImg = $g.find('.swiper-slide-next img');

                if ($prevImg.hasClass('swiper-lazy-loaded')) {
                    setVerticalPhoto($prevImg);
                }

                if ($nextImg.hasClass('swiper-lazy-loaded')) {
                    setVerticalPhoto($nextImg);
                }
            });*/

            //setVerticalPhoto($g.find('.swiper-slide-active img'));

            /*$g.find('img').each(function () {
                let $currImg = $(this);
                let _currImgSrc = $currImg.data('src');

                if ($currImg.outerHeight() > $currImg.outerWidth()) {
                    $currImg.closest('.slide').addClass('_vertical');
                }

                $currImg.parent().append(`<div class="vertical-photo-back" style="background-image: url(${_currImgSrc})"></div>`);
            });*/

            $container.find('.js-slider-next').on('click', () => {
                swiper.slideNext();
            });

            $container.find('.js-slider-prev').on('click', () => {
                swiper.slidePrev();
            });

            if ($container.find('.js-map').length) {
                initMaps();
            }
        }
    });

    unlock();
}

function setVerticalPhoto(_img) {
    // console.log(_img, _img.outerHeight(), _img.outerWidth());

    if (_img.outerHeight() > _img.outerWidth()) {
        _img.closest('.slide').addClass('_vertical');
    }

    if (!_img.parent().find('.vertical-photo-back').length) {
        _img.parent().append(`<div class="vertical-photo-back" style="background-image: url(${_img.attr('src')})"></div>`);
    }
}



// WEBPACK FOOTER //
// ./_src/js/modules/Slider.js